import React, { Component } from 'react';

//componentes
import ReporteCitas from './reporteCitas'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteCitas />
            </div>
        );
    }

}
export default Index;